import { Component } from '@angular/core';

import { BaseComponent } from '../_base.component';
import { FormGridWithRows } from '../../../form.interface';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-textarea',
  templateUrl: './textarea.component.html',
  host: {
    class: 'uex-input-textarea'
  }
})
export class InputTextareaComponent extends BaseComponent<string> {

  public getRows(): number {
    return (<FormGridWithRows>this.schema.grid).rows;
  }

}
